export default function ($rootScope) {
  return{
    link: function (scope, element) {
      element.addClass('hide');
      $rootScope.$on('$routeChangeStart', function () {
        element.removeClass('hide');
      });
      $rootScope.$on('$routeChangeSuccess', function () {
        element.addClass('hide');
      });
    }
  };
};



// WEBPACK FOOTER //
// ./client/directives/MapLoad.js